import clsx from 'clsx';
import { MockDataBar } from 'components/Mock/MockDataBar';

import styles from './ContactsMock.module.scss';

interface ContactsMockProps {
  className?: string;
}

const contactLabels = [
  'Email',
  'Phone',
  'Instagram',
  'X',
  'TikTok',
  'Guardian Name',
  'Guardian Email',
  'Guardian Phone',
  'Agent Name',
  'Agency',
  'Agent Email',
  'Agent Phone',
];

export const ContactsMock = ({ className }: ContactsMockProps) => {
  return (
    <div className={clsx(styles.block, className)}>
      <ul>
        {contactLabels.map((label, index) => (
          <li key={index}>
            <span>{label}</span> <MockDataBar />
          </li>
        ))}
      </ul>
    </div>
  );
};
